import { pxToRem } from 'utils/convert';
import { isTypeString } from 'utils/helpers';
import { INSIGHT_PANEL_SIZES } from '../../../constants';
import { InsightType } from '../../../types';
import {
  InsightPanelHeaderWrapper,
  InsightPanelHeader as InsightPanelHeaderComponent,
} from './InsightPanel.styled';

export type InsightHeaderProps = {
  size?: INSIGHT_PANEL_SIZES;
  title?: string | React.ReactNode;
  showDivider?: boolean;
  showSelect?: boolean;
  type?: InsightType | null;
};

export const INSIGHT_HEADER_WIDTHS: Record<InsightType, string | null> = {
  [InsightType.demographics]: pxToRem(365),
  [InsightType.behavioral]: pxToRem(125),
  [InsightType.listUsage]: null,
};

export const testIds = { header: 'insight-header' };

export const InsightPanelHeader = ({
  title,
  size,
  showDivider = false,
  // showSelect = false,
  type = null,
}: InsightHeaderProps) => {
  const insightTitle = isTypeString(title) ? title : '';

  if (!title) return null;

  return (
    <InsightPanelHeaderWrapper data-test={title} data-divider={showDivider} data-size={size}>
      <InsightPanelHeaderComponent
        data-test={testIds.header}
        data-title={insightTitle}
        data-width={type ? INSIGHT_HEADER_WIDTHS[type] : ''}
      >
        {title}
      </InsightPanelHeaderComponent>
      {/* {showSelect && <ConversionRateSelect />} */}
    </InsightPanelHeaderWrapper>
  );
};
